(function(){
  'use strict';
  function text(el){ return (el && (el.getAttribute('data-affiliate-product') || el.textContent) || '').replace(/\s+/g,' ').trim().slice(0,160); }
  function sectionName(link){
    var named=link.closest('[data-affiliate-section]');
    if(named) return named.getAttribute('data-affiliate-section') || '';
    var section=link.closest('section,article,.shopify-section');
    if(!section) return '';
    var heading=section.querySelector('h1,h2,h3,h4');
    return text(heading).slice(0,100);
  }
  function productName(link){
    if(link.dataset.affiliateProduct) return link.dataset.affiliateProduct;
    var card=link.closest('article,.stb-product,.card,.product-card,.sch-marine-pick');
    if(card){ var h=card.querySelector('h1,h2,h3,h4'); if(h) return text(h); }
    return text(link);
  }
  function isAffiliate(url){ return /(^|\.)amazon\./i.test(url.hostname) || /(^|\.)amzn\.to$/i.test(url.hostname); }
  document.addEventListener('click',function(e){
    var link=e.target.closest && e.target.closest('a[href]'); if(!link) return;
    var url; try{ url=new URL(link.href,location.href); }catch(err){ return; }
    if(!isAffiliate(url)) return;
    var payload={affiliate_domain:url.hostname,affiliate_tag:url.searchParams.get('tag') || '',affiliate_product:productName(link),affiliate_section:link.dataset.affiliateSection || sectionName(link),affiliate_link_text:text(link),destination_url:url.href,page_path:location.pathname,page_title:document.title};
    if(typeof window.gtag==='function'){ window.gtag('event','affiliate_click',payload); }
    else{ window.dataLayer=window.dataLayer||[]; window.dataLayer.push(Object.assign({event:'affiliate_click'},payload)); }
  },true);
})();
